// Only explicit identity-provider rejections prove that renewal cannot continue.
// Network, timeout, configuration and server failures must leave credentials intact.
export function isSessionRejection(error: unknown): boolean {
  const code = (error as { error?: unknown } | null)?.error;
  return typeof code === 'string' && ['invalid_grant', 'login_required', 'interaction_required', 'consent_required', 'invalid_token'].includes(code);
}
export class SessionEndedError extends Error {
  constructor() { super('Your session has ended. Please sign in again.'); this.name = 'SessionEndedError'; }
}
